module.exports = __webpack_public_path__ + "img/lores_panel.60eda9ee.png";